/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { Content } from '@styles/base.style'
import MyBank from '@views/MyBank'
import { HISTORY_TYPE } from '@constants/index'

const ItemHistoryPopup: React.FC = () => {
  const contentCss = css`
    height: 100%;
    overflow: auto;
    text-align: left;
  `
  return (
    <Content css={contentCss}>
      <MyBank historyType={HISTORY_TYPE.ITEM}/>
    </Content>
  )
}
export default observer(ItemHistoryPopup)
